import { FC } from 'react';
import { injectIntl, IntlShape } from 'react-intl';

import messages from 'containers/ExpertExpertise/messages';
import { translate } from 'containers/services/translate';
import DropDownDecisionMenu from 'components/SahamDropDown/DropDownDecisionMenu';

export interface ActionButtonProps {
  intl: IntlShape;
  setDropDown: Function;
  dropDown: any;
  handleCreateReport: Function;
  handleCreateNoticeDeficiency: Function;
  handleCreatePostPonement: Function;
  isAppreciation: boolean;
  displayButtonCreateRapport: boolean;
  isTransaction: boolean;
}

export const ActionButton: FC<ActionButtonProps> = props => {
  const dropDownMenuElements = props.isAppreciation
    ? [
        {
          title: translate(messages.appreciationExpertise, props),
          action: /* istanbul ignore next */ () => props.handleCreateReport(),
        },
      ]
    : props.displayButtonCreateRapport
    ? [
        {
          title: translate(messages.noticeDeficiency, props),
          action: /* istanbul ignore next */ () =>
            props.handleCreateNoticeDeficiency(),
        },
      ]
    : props.isTransaction
    ? [
        {
          title: translate(messages.consultingReport, props),
          action: () => props.handleCreateReport(),
        },
      ]
    : [
        {
          title: translate(messages.consultingReport, props),
          action: () => props.handleCreateReport(),
        },
        {
          title: translate(messages.noticeDeficiency, props),
          action: () => props.handleCreateNoticeDeficiency(),
        },
        {
          title: translate(messages.postponementsExpertise, props),
          action: () => props.handleCreatePostPonement(),
        },
      ];

  return (
    <DropDownDecisionMenu
      setDropDown={props.setDropDown}
      dropDown={props.dropDown}
      label={translate(messages.managerActionTitle, props)}
      menuElements={dropDownMenuElements}
    />
  );
};

export default injectIntl(ActionButton);
